// src/app/core/mainPage/mainPagecomp/TopModelsSection/TopModelsSection.tsx
import { motion } from "motion/react";
import { useTranslation } from "@/app/core/ui/theme/LanguageProvider";
import { TopModelCard } from "./comp/TopModelCard";
import { LatestModelCard } from "./comp/LatestModelCard";
import { TopModelsSkeleton } from "./comp/TopModelsSkeleton";
import type { TopModelsSectionProps } from "./comp/types";

export function TopModelsSection({
  textModel,
  imageModel,
  videoModel,
  latestModel,
  isLoading = false,
  onModelClick,
}: TopModelsSectionProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return <TopModelsSkeleton />;
  }

  const animationProps = {
    initial: { opacity: 0, y: 12 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true },
    transition: { duration: 0.3 },
  };

  return (
    <motion.section {...animationProps} className="px-4 py-6 mx-auto max-w-7xl">
      <h2 className="text-xl font-bold text-foreground mb-4 drop-shadow text-center">
        {t('topModels')}
      </h2>

      <div className="grid grid-cols-3 gap-3 mb-3">
        <TopModelCard
          data={textModel}
          category="text"
          onSelect={() => onModelClick(textModel.id, 'text')}
        />
        <TopModelCard
          data={imageModel}
          category="image"
          onSelect={() => onModelClick(imageModel.id, 'image')}
        />
        <TopModelCard
          data={videoModel}
          category="video"
          onSelect={() => onModelClick(videoModel.id, 'video')}
        />
      </div>

      <LatestModelCard
        data={latestModel}
        onSelect={() => onModelClick(latestModel.id, 'text')}
      />
    </motion.section>
  );
}